import Axios from 'axios';

export const getActivityMedia = (id) => {
  return Axios.get(`${process.env.ACTIVITY_MEDIA_API_V1}/activity/${id}`)
    .then((response) => response?.data)
    .catch(() => undefined);
};
